<template>
  <div class="report-card" v-if="evidenceList.length">
    <div class="report-card-title">
      举报{{type[this.infoData.reportType]}}
    </div>
    <div class="report-card-body" v-for="(item,index) in evidenceList" :key="index">
      <z-image :src="item.firstPic" fit="cover"/>
      <div class="report-card-body-right">
        <span>{{item.content}}</span>
        <div class="report-card-body-right-bottom">
          <span>¥{{item.pirce}}</span>
          <span v-if="infoData.reportType=='3'">{{item.orderStatus.trim()}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Image } from '@zz-common/zz-ui';
export default {
  name: 'ReportCard',
  props: {
    infoData: {
      default: () => {}
    }
  },
  data() {
    return {
      type: {
        1: '商品',
        2: '私信',
        3: '订单',
        4: '其他',
        5: '视频',
        6: '图片',
        7: '短视频',
        8: 'url',
        9: '帖子',
        11: '直播'
      }
    }
  },
  computed: {
    evidenceList() {
      return this.infoData.evidenceList || []
    }
  },
  components: {
    'z-image': Image
  }
}
</script>

<style lang="less" scoped>
  @import 'index.less';
</style>